export const MakeId = (length = 0): string => {
  const arr: string[] = [];
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  const GetRadomNum = (length = 1) => Math.floor(Math.random() * length);
  const GetRadomChar = (length = 1) => characters.charAt(GetRadomNum(length));

  for (let i = 0; i < length; i++) {
    let char = GetRadomChar(characters.length);

    while (i === 0 && /[0-9]/.test(char)) {
      char = GetRadomChar(characters.length);
    }

    arr.push(char);
  }
  return arr.join("");
};
